// Last sort per table id, so a table re-rendered by an htmx swap keeps the user's sort.
const sortStates = new Map();

export function makeTableSortable(tableElement) {
  if (typeof Tablesort === 'undefined') {
    console.warn('Tablesort is not loaded!')
    return;
  }

  const sorter = new Tablesort(tableElement);
  const key = tableElement.id;
  if (!key) {
    return;
  }

  tableElement.addEventListener('afterSort', () => {
    const header = sorter.current;
    if (header) {
      sortStates.set(key, { column: header.cellIndex, order: header.getAttribute('aria-sort') });
    }
  });

  const state = sortStates.get(key);
  const headerRow = tableElement.tHead && tableElement.tHead.rows[tableElement.tHead.rows.length - 1];
  const header = state && headerRow && headerRow.cells[state.column];
  if (header && header.getAttribute('data-sort-method') !== 'none') {
    // sortTable with update=true sorts by the header's existing aria-sort instead of toggling it
    header.setAttribute('aria-sort', state.order);
    sorter.current = header;
    sorter.sortTable(header, true);
  }
}
